import { render, staticRenderFns } from "./EmployeeTrainingView.vue?vue&type=template&id=2687461a&scoped=true&"
import script from "./EmployeeTrainingView.vue?vue&type=script&lang=js&"
export * from "./EmployeeTrainingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2687461a",
  null
  
)

export default component.exports